import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('élément #root introuvable dans le document');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
